import { prefixerT } from './common'

export const ROUTE_APROBAR_SOLICITUD = prefixerT('aprobar-solicitud')
